import { inject, InjectionToken } from '@angular/core';
import { DOCUMENT } from '@angular/common';

/**
 * Serial connection API. Will be undefined in unsupported environments.
 */
export const BROWSER_SERIAL_API = new InjectionToken('BROWSER_SERIAL_API', {
	providedIn: 'root',
	factory: () => (navigator as any).serial,
});

export const WINDOW = new InjectionToken('WINDOW', {
	providedIn: 'root',
	factory: () => inject(DOCUMENT).defaultView,
});
